import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { isAdmin } from 'utils/isAdmin';

export const SmoothLineChart = ({
  height = 200,
  width = 200,
  value = [10, 30, 40],
  label = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
  centeredValue = 220,
  name = 'name',
}) => {
  const isAdminRoute = isAdmin() ? '#000' : '#fefefe';

  const options = {
    title: {
      text: name, // Tiêu đề biểu đồ
      left: 'center',
      top: '90%',
      textStyle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: isAdminRoute,
      },
    },
    grid: {
      top: '0%',
      bottom: '0%',
      left: '0%',
      right: '0%',
    },
    xAxis: {
      show: false, // Hide x-axis
      type: 'category',
      data: label,
    },
    yAxis: {
      show: false, // Hide y-axis
      type: 'value',
    },
    series: [
      {
        data: value, // Example data points
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 3,
          color: '#4A90E2', // Line color
        },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(74, 144, 226, 0.5)' }, // Top color
              { offset: 1, color: 'rgba(74, 144, 226, 0)' }, // Bottom color
            ],
          },
        },
        symbol: 'none', // Remove points on the line
      },
    ],
    tooltip: {
      show: false, // Disable tooltips
    },
    graphic: [
      {
        type: 'text',
        left: 'center',
        top: '70%',
        style: {
          text: `${centeredValue} V`, // Centered value
          fontSize: 30,
          fontWeight: 'bold',
          fill: isAdminRoute, // Text color
        },
      },
    ],
  };
  return (
    <div className="smooth-line-chart">
      <ReactEcharts
        option={options}
        style={{ width: width, height: height }}
        onEvents={() => {}}
      ></ReactEcharts>
    </div>
  );
};
